// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"dcd5072b","290":"821c5eb7","463":"51dc959b","609":"d7a640e4","612":"44f587ed","722":"bded2af6","758":"0e7343ac"}[chunkId] + ".chunk.js";
};